import type { FC } from "react";
import type { ISelectedDomain, IDomains } from "app/pages/website-analysis/audience-interests/single/types";
import { DomainsDropdown } from "app/pages/website-analysis/audience-interests/single/CrossBrowsingOvertime/DomainsDropdown";
import styled from "styled-components";
import { chosenSites as chosenSitesService } from "app/common/services/chosenSites";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { i18nFilter } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

interface IActionButtons {
    selectedDomains: ISelectedDomain;
    setSelectedDomains: (selectedDomains: ISelectedDomain) => void;
    domains: IDomains;
}

const Container = styled.div`
    display: flex;
    padding: 24px;
    align-items: center;
    gap: 16px;
`;

const Text = styled.span`
    display: block;
    ${setFontVariant("input2", colorsPalettes.carbon[500])}
`;

const DropdownContainer = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;

    [data-automation-icon-name="arrow"] svg {
        width: 10px;
        height: 5px;
    }
`;

export const ActionButtons: FC<IActionButtons> = (props) => {
    const { selectedDomains, setSelectedDomains } = props;
    const { alsoVisited, visitorsOf } = selectedDomains;
    const domainsMD = chosenSitesService.sitelistForLegend();
    const i18n = i18nFilter();
    const track = (openClose: "Open" | "Close") => (site: "SiteA" | "SiteB", domain?: string) => {
        const eventName = domain ? `${openClose}/${site}/${domain}` : `${openClose}/${site}`;
        allTrackers.trackEvent("Drop Down", "click", eventName);
    };
    const trackOpen = track("Open");
    const trackClose = track("Close");
    return (
        <Container>
            <DropdownContainer>
                <Text>{i18n("audience.interest.overtime.visitors.of")}</Text>
                <DomainsDropdown
                    domainsMD={domainsMD}
                    disablesDomain={alsoVisited}
                    selectedDomainText={visitorsOf}
                    onClick={(domain) => {
                        setSelectedDomains({ ...selectedDomains, visitorsOf: domain });
                        trackClose("SiteA", domain);
                    }}
                    onOpen={() => trackOpen("SiteA")}
                />
            </DropdownContainer>
            <DropdownContainer>
                <Text>{i18n("audience.interest.overtime.also.visited")}</Text>
                <DomainsDropdown
                    domainsMD={domainsMD}
                    disablesDomain={visitorsOf}
                    selectedDomainText={alsoVisited}
                    onClick={(domain) => {
                        setSelectedDomains({ ...selectedDomains, alsoVisited: domain });
                        trackClose("SiteB", domain);
                    }}
                    onOpen={() => trackOpen("SiteB")}
                />
            </DropdownContainer>
        </Container>
    );
};
